import React, { useMemo } from "react"
import CustomImage from "components/atoms/Image/CustomImage"

interface IProps {
    img: string

}

const BlurView = React.memo(({ img }: IProps) => {


    // ✅ Always apply blur
    const blurStyle = useMemo(() => ({
        filter: `blur(48px)`,
        opacity: 1,
        transform: "scale(1)",
        willChange: "filter",
    }), [])



    return (
        <div className={` sm:h-full   w-full   fixed inset-0 ${false ? "z-50" : "-z-10"}`}>
            <CustomImage style={blurStyle} alt="event image "
                src={`${img}`}
                fill
                className={`object-cover  transition-opacity duration-1000 ${true ? "opacity-100 z-10" : "opacity-0 z-0"
                    } absolute top-0 left-0 w-full h-full`}
            />

            <div className="absolute  w-full h-full inset-0 bg-[#0000003b] z-50" />
        </div>

    )
})

BlurView.displayName = 'BlurView'

export default BlurView
